export default [
  {
    path: "/ugg1RIKaeYHN1KK8P2go",
    children: [
      {
        path: "lgas",
        name: "ListLga",
        meta: {
          title: "LGA",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/lga/index.vue"),
      },
      {
        path: "new",
        name: "CreateLga",
        meta: {
          title: "Create LGA",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/lga/new.vue"),
      },
      {
        path: ":lg/view",
        name: "ViewLga",
        meta: {
          title: "View LGA",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/lga/view.vue"),
      },
      {
        path: ":lg/edit",
        name: "EditLga",
        meta: {
          title: "Edit LGA",
          authRequired: true,
          acc: ["y51656"],
        },
        component: () => import("@/views/lga/edit.vue"),
      },
    ],
  },
];
